/**
 * items_silver_share.js
 * Social-share, copy-link, and PDF-print helpers for the items-silver widget.
 * Auto-bundled by Vite's import.meta.glob — do NOT import manually.
 *
 * Data contract (emitted inline by items_silver.jinja):
 *   window._itemShareData = { title: "...", maker: "...", media: "..." };
 */

function _shareData() {
    return window._itemShareData || {};
}

function shareOnTwitter() {
    const d    = _shareData();
    const url  = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(d.title + (d.maker ? ' - ' + d.maker : ''));
    window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank', 'width=550,height=420');
}

function shareOnFacebook() {
    const d    = _shareData();
    const url  = encodeURIComponent(window.location.href);
    const desc = encodeURIComponent(d.title + (d.maker ? ' by ' + d.maker : ''));
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${desc}`, '_blank', 'width=600,height=400');
}

function shareOnLinkedIn() {
    const url  = encodeURIComponent(window.location.href);
    const shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
    const width = 600, height = 600;
    const left  = (window.innerWidth  - width)  / 2;
    const top   = (window.innerHeight - height) / 2;
    window.open(shareUrl, 'linkedin-share', `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`);
}

function shareOnPinterest() {
    const d    = _shareData();
    const url  = window.location.href;
    const desc = d.title + (d.maker ? ' by ' + d.maker : '');

    let imageUrl = d.media || '';
    if (imageUrl && !imageUrl.startsWith('http')) {
        imageUrl = window.location.origin + (imageUrl.startsWith('/') ? '' : '/') + imageUrl;
    }

    const params = new URLSearchParams({ url, description: desc });
    if (imageUrl) params.append('media', imageUrl);

    const shareUrl = `https://www.pinterest.com/pin/create/button/?${params.toString()}`;
    const width = 750, height = 600;
    const left  = (window.innerWidth  - width)  / 2;
    const top   = (window.innerHeight - height) / 2;
    window.open(shareUrl, 'pinterest-share', `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,scrollbars=yes,resizable=yes`);
}

async function printPDF(pdfUrl) {
    if (!pdfUrl || pdfUrl === '#') { console.error('No PDF URL provided'); return; }

    const printWindow = window.open('about:blank', '_blank');
    if (!printWindow) { alert('Please allow popups for this site to print PDFs'); return; }

    document.body.style.cursor = 'wait';
    try {
        const response = await fetch(pdfUrl);
        if (!response.ok) throw new Error('Failed to fetch PDF');
        const blobUrl = URL.createObjectURL(await response.blob());
        printWindow.location.href = blobUrl;
        setTimeout(() => { printWindow.print(); document.body.style.cursor = 'default'; }, 2000);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 120000);
    } catch (error) {
        console.error('Error loading PDF:', error);
        document.body.style.cursor = 'default';
        printWindow.close();
        window.open(pdfUrl, '_blank');
    }
}

function fallbackCopy(url, span, originalText, button, originalClasses) {
    const textArea = document.createElement('textarea');
    Object.assign(textArea.style, { position: 'fixed', left: '-999999px', top: '-999999px' });
    textArea.value = url;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        if (document.execCommand('copy')) {
            button.className = button.className.replace(/bg-\w+/g, '').replace(/text-\w+-?\w*/g, '').replace(/hover:bg-\w+/g, '');
            button.classList.add('bg-success', 'text-white');
            span.textContent = 'Copied!';
            setTimeout(() => { button.className = originalClasses; span.textContent = originalText; }, 2000);
        } else {
            alert('Copy failed. Please copy manually: ' + url);
        }
    } catch (err) {
        console.error('Fallback copy failed:', err);
        alert('Unable to copy to clipboard. Please copy the URL manually: ' + url);
    }
    document.body.removeChild(textArea);
}

function copyToClipboard(button) {
    if (!button.classList.contains('w-full')) button = button.closest('button');
    const url          = window.location.href;
    const span         = button.querySelector('span');
    const originalText = span.textContent;
    const originalClasses = button.className;

    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(() => {
            button.className = button.className.replace(/bg-\w+/g, '').replace(/text-\w+-?\w*/g, '').replace(/hover:bg-\w+/g, '');
            button.classList.add('bg-success', 'text-white');
            span.textContent = 'Copied!';
            setTimeout(() => { button.className = originalClasses; span.textContent = originalText; }, 2000);
        }).catch(err => {
            console.error('Copy failed:', err);
            fallbackCopy(url, span, originalText, button, originalClasses);
        });
    } else {
        fallbackCopy(url, span, originalText, button, originalClasses);
    }
}

window.shareOnTwitter   = shareOnTwitter;
window.shareOnFacebook  = shareOnFacebook;
window.shareOnLinkedIn  = shareOnLinkedIn;
window.shareOnPinterest = shareOnPinterest;
window.printPDF         = printPDF;
window.copyToClipboard  = copyToClipboard;
